export const environment = {
    apiUrlBase: 'https://alt41r-dev.intrustservices.co',
    apiUrlAsm: 'https://asm-dev.intrustservices.co/api',
    recaptcha: {
        siteKeyV2: 'YOUR_RECAPTCHA_V2_SITE_KEY',
        siteKeyV3: '6LfO6VsrAAAAAFCNn5aNRjkZo5TN4k3yXFTdCpj7',
    },
    production: false,
};
